module.exports = __webpack_public_path__ + "media/images/emblems/Eclepens-coat_of_arms-90c8972715e9674e6df8859e91617869.svg";